import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const menu_items = [
  { label: 'Neighborhoods', href: 'https://www.houstonproperties.com/houston-neighborhoods?np=1', target: '_blank' },
  { label: 'Value My Current Home', href: 'https://my.houstonproperties.com/home-valuation/55156FEv/activity/', target: '_blank' },
];

export const NavBar = ({ user = {}, showNavBar = false, publicId = null, onHomeClick = () => {}, onToggleMenu = () => {} }) => {
  const isStaff = user && !!user.staff_session;

  if (!showNavBar) {
    return null;
  }
  return (
    <div className="flex flex-row justify-between px-4 w-full bg-white border-b items-center shadow">
      <div className="py-2">
        <Logo publicId={publicId} onNavigateHome={onHomeClick} />
      </div>
      <div className="sm:hidden p-2 cursor-pointer" onClick={onToggleMenu}>
        <FontAwesomeIcon icon={['fas', 'bars']} className="text-primary1 text-xl cursor-pointer" />
      </div>
      <ul className="flex-1 flex-row justify-end items-center hidden sm:flex">
        {menu_items.map(({ label, href, action, target }) => (
          <li className="px-2 py-4 hover:bg-primary2 hover:text-white cursor-pointer font-primary-bold text-primary2" key={label}>
            <Link to={{ pathname: href }} target={target}>
              {label === 'owner' ? (user.lead_owner ? `Ask ${user.lead_owner.name}` : '') : label}
            </Link>
          </li>
        ))}
        {isStaff && !!user.profile_url && (
          <li className="px-2 py-4 hover:bg-primary2 hover:text-white cursor-pointer font-primary-bold text-yellow-600">
            <a href={user.profile_url} rel="noreferrer noopener" target="_blank">
              Edit {user.name} {user.surname} <FontAwesomeIcon icon={['fas', 'edit']} className="text-base text-yellow-600 mr-2" />
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};
